var _rect, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 218,
    viewBox: "0 0 309 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 309,
    height: 218,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212.744 126.823H229.198C229.668 126.823 230.765 126.666 231.235 126.666C234.369 126.04 237.033 123.221 237.033 119.307C237.033 115.548 234.369 112.73 231.235 111.947C230.765 111.79 229.825 111.79 229.198 111.79H212.744V126.823Z",
    fill: "url(#paint0_linear_466_6022)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.317 23C211.647 23 198.798 35.6841 198.798 51.5V81.0962H239.07C240.01 81.0962 241.107 81.0962 241.891 81.2528C250.979 81.7226 257.717 86.4204 257.717 94.5633C257.717 100.984 253.173 106.464 244.711 107.561V107.874C253.957 108.5 261.008 113.668 261.008 121.654C261.008 130.267 253.173 135.904 242.831 135.904H198.641V193.844H240.48C256.15 193.844 269 181.159 269 165.344V23H227.317Z",
    fill: "url(#paint1_linear_466_6022)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234.996 96.4428C234.996 92.6846 232.332 90.1791 229.198 89.7093C228.884 89.7093 228.101 89.5527 227.631 89.5527H212.744V103.333H227.631C228.101 103.333 229.041 103.333 229.198 103.176C232.332 102.707 234.996 100.201 234.996 96.4428Z",
    fill: "url(#paint2_linear_466_6022)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6763 23C54.0062 23 41.1567 35.6841 41.1567 51.5V121.811C49.1485 125.725 57.4536 128.231 65.7588 128.231C75.6309 128.231 80.9588 122.28 80.9588 114.137V80.9396H105.404V113.981C105.404 126.822 97.4124 137.313 70.3031 137.313C53.8495 137.313 41 133.712 41 133.712V193.687H82.8392C98.5093 193.687 111.359 181.003 111.359 165.187V23H69.6763Z",
    fill: "url(#paint3_linear_466_6022)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.497 23C132.827 23 119.977 35.6841 119.977 51.5V88.7693C127.185 82.6621 139.721 78.7473 159.936 79.6869C170.748 80.1567 182.344 83.1319 182.344 83.1319V95.1896C176.546 92.2144 169.651 89.5523 160.719 88.9259C145.363 87.8297 136.117 95.3462 136.117 108.5C136.117 121.811 145.363 129.327 160.719 128.074C169.651 127.448 176.546 124.629 182.344 121.811V133.868C182.344 133.868 170.905 136.844 159.936 137.313C139.721 138.253 127.185 134.338 119.977 128.231V194H161.816C177.486 194 190.336 181.316 190.336 165.5V23H148.497Z",
    fill: "url(#paint4_linear_466_6022)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_466_6022",
    x1: 198.772,
    y1: 119.325,
    x2: 269.189,
    y2: 119.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_466_6022",
    x1: 198.77,
    y1: 108.353,
    x2: 269.192,
    y2: 108.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_466_6022",
    x1: 198.77,
    y1: 96.4233,
    x2: 269.19,
    y2: 96.4233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_466_6022",
    x1: 41.1235,
    y1: 108.353,
    x2: 112.631,
    y2: 108.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_466_6022",
    x1: 119.572,
    y1: 108.353,
    x2: 189.022,
    y2: 108.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.d927111d1a738d6e04883082fa37257a.svg";
export { ForwardRef as ReactComponent };